import { fetchData } from "./fetchData";


export const getAllSeasons = async () => {
    try {
        const route = `/seasons`;

        const options = {
            method: 'GET'
        }

        let response = await fetchData(route, options);

        return response;
    } catch (error) {
        console.log(error);
    }
}